import { useRef, useState, useEffect } from "react";
import { axiosAPIWithJson, axiosGet } from "../../util/axios";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";

import { DataGrid, GridColDef } from "@mui/x-data-grid";
import moment from "moment";

import {
  OpenSnackBarWithResultFail,
  OpenSnackBarWithResultSuccess,
} from "../../redux/common/snackBar/thunk";
import {
  ClearSelectedBinThunk,
  UpdateBinListThunk,
  initBinDetailThunk,
  initBinHistoryThunk,
  initBinListThunk,
} from "../../redux/BinType/thunk";
import { Button, Grid } from "@mui/material";
import { EditNote } from "@mui/icons-material";
import { BinList } from "../../redux/BinType/state";
import FormDialog from "../../component/common/FormDialog";
import BinForm from "../../component/bin/BinForm";
import { Cancel, CheckCircle } from "@mui/icons-material/";
import { handleDownLoadExcel } from "../../util/excel";
import BinGroupManagement from "../../component/bin/BinGroupManagement";
import { ButtonTextGrid } from "../..";



function BinManage() {
  const dispatch = useDispatch<IRootThunkDispatch>();
  const dataFetchedRef = useRef(false);
  const { binListRootState, selectedBinItem } = useSelector(
    (state: IRootState) => state.binListState
  );
  const { nav_bar_detail,navList,pageIndex} = useSelector(
    (state: IRootState) => state.initNavBarState
  );

  const [OpenEditDialog, setOpenEditDialog] = useState<boolean>(false);
  const [openHistoryDialog, setOpenHistoryDialog] = useState<boolean>(false);
  const [detailPage ,setDetailPage] = useState(navList[pageIndex].nav_bar_detail.split(',')[0] )


  useEffect(() => {
    const controller = new AbortController();
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;

    getBinData();
    return () => {
      controller.abort();

    };
  }, []);

  useEffect(()=>{
    if (nav_bar_detail){
        setDetailPage(nav_bar_detail)
    }

  },[nav_bar_detail])

  async function getBinData() {
    dispatch(OpenLoadingBarThunk(true));
    const result = await axiosGet("/api/bin/binCMS");
    if (result.data.success) {
      dispatch(OpenLoadingBarThunk(false));
      dispatch(initBinListThunk(result.data.binList));
    } else {
      dispatch(OpenSnackBarWithResultFail("無法下載回收桶資料"));
    }
  }

  function handleEditBinBtn(binInfo?: BinList) {
    if (binInfo) {
      dispatch(initBinDetailThunk(binInfo));
    }
    setOpenEditDialog(true);
  }

  function handleDialogClose() {
    dispatch(ClearSelectedBinThunk());
    setOpenEditDialog(false);
    setOpenHistoryDialog(false);
  }

  async function handleSubmitBin() {
    let result;

    if (!selectedBinItem.location_cn) {
      dispatch(OpenSnackBarWithResultFail("你未有填寫廁所地址"));
      return;
    }
    if (!selectedBinItem.code) {
      dispatch(OpenSnackBarWithResultFail("你未有填寫廁所編號"));
      return;
    }

    if (!selectedBinItem.bin_type_id) {
      dispatch(OpenSnackBarWithResultFail("你未有填寫廁所類型"));
      return;
    }
    if (!selectedBinItem.contract_id) {
      dispatch(OpenSnackBarWithResultFail("你未有填寫廁所合約"));
      return;
    }

    if (!selectedBinItem.zone_id) {
      dispatch(OpenSnackBarWithResultFail("你未有填寫廁所區份"));
      return;
    }

    dispatch(OpenLoadingBarThunk(true));

    if (selectedBinItem.bin_id) {
      // for update
      result = await axiosAPIWithJson.put(
        `/api/bin/${selectedBinItem.bin_id}`,
        selectedBinItem as any
      );
    } else {
      // for insert
      result = await axiosAPIWithJson.post(`/api/bin`, selectedBinItem);
    }

    if (result?.data.success) {
      dispatch(OpenSnackBarWithResultSuccess(result.data.message));
      if (binListRootState) {
        selectedBinItem.bin_id
          ? dispatch(UpdateBinListThunk(binListRootState, selectedBinItem))
          : getBinData();

        handleDialogClose();
      }
      dispatch(ClearSelectedBinThunk());
      dispatch(OpenLoadingBarThunk(false));
      handleDialogClose();
    } else {
      dispatch(OpenSnackBarWithResultFail(result?.data.message));
    }
  }

  function handleExcelBtn() {
    handleDownLoadExcel(dispatch, "Bin");
  }

  async function handleBinHistoryBtn(binInfo?: BinList) {
    dispatch(OpenLoadingBarThunk(true));
    const result = await axiosGet(`/api/bin/binHistory/${binInfo?.bin_id}`);
    if (result.data.success) {
      dispatch(OpenLoadingBarThunk(false));
      dispatch(initBinHistoryThunk(result.data.binHistoryList));
    } else {
      dispatch(OpenSnackBarWithResultFail("無法下載回收桶歷史"));
    }
    setOpenHistoryDialog(true);
  }

  const columns: GridColDef[] = [
    { field: "code", headerName: "參考編號", flex: 1 },
    { field: "toilet_number", headerName: "廁所編號", flex: 1 },
    { field: "location_cn", headerName: "廁所地址", flex: 4 },
    {
      field: "contract",
      headerName: "合約",
      flex: 2,
    },
    {
      field: "zone_name",
      headerName: "區份",
      flex: 2,
    },
    {
      field: "bin_type",
      headerName: "類型",
      flex: 1,
    },
    {
      field: "update_date",
      headerName: "最後修訂日期",
      flex: 2,
      renderCell: (data) => (
        <div>
          {data.value
            ? moment.utc(data.value).format("YYYY-MM-DD HH:mm:ss")
            : null}
        </div>
      ),
    },

    {
      field: "status",
      headerName: "狀況",
      flex: 1,
      renderCell: (data) => (
        <div>
          {data.value === 0 ? (
            <Cancel style={{ color: "red" }} />
          ) : (
            <CheckCircle style={{ color: "green" }} />
          )}
        </div>
      ),
    },

{
      field: "group_name_tc",
      headerName: "隸屬組合",
      flex: 2,
     
    },

    {
      field: "action",
      headerName: "更新",
      flex: 1,
      renderCell: (data) => (
        <div>
          <Button
            variant="contained"
            onClick={() => handleEditBinBtn(data.row)}
          >
            <ButtonTextGrid>
            <EditNote />
            <Grid>更新</Grid>
            </ButtonTextGrid>

          </Button>
        </div>
      ),
    },


    { field: "value", headerName: "ID" },
  ];

  return (
    <Grid>
      <Grid>
        {detailPage === "單件" && (
          <Grid>
            <Grid style={{ display: "flex", justifyContent: "space-between" }}>
              <Button variant="contained" onClick={() => handleEditBinBtn()}>
                <ButtonTextGrid>
                新增廁所
                </ButtonTextGrid>

              </Button>

              <Button variant="contained" onClick={() => handleExcelBtn()}>
                <ButtonTextGrid>
下載Excel
                </ButtonTextGrid>
                
                
              </Button>
            </Grid>
            <div style={{ height: "900px", width: "100%" }}>
              <DataGrid
                rows={binListRootState || []}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 30 },
                  },
                }}
                pageSizeOptions={[5, 10]}
                checkboxSelection
                getRowId={(row) => row.bin_id}
              />
            </div>

            <FormDialog
              title="新增廁所"
              open={OpenEditDialog}
              handleClose={handleDialogClose}
              size="lg"
              handleSubmit={handleSubmitBin}
            >
              <BinForm />
            </FormDialog>

 
          </Grid>
        )}

        {detailPage==='組合' && (
            <BinGroupManagement/>
        )}
      </Grid>
    </Grid>
  );
}

export default BinManage;
